import { DefaultValidator } from '..'
import { translateValidator } from '../../i18next/i18nextHelpers'
import { withDefaultValidator } from '../formValidators.utils'

const defaultTranslateKey = 'validator.validSwissPostalCode'

export const validSwissPostalCode = value => /^\d{4}$/i.test(String(value))

export const validSwissPostalCodeTranslated: DefaultValidator = withDefaultValidator(
  (localeKey?: string) =>
    translateValidator(validSwissPostalCode, localeKey || defaultTranslateKey),
)
